"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _Button = _interopRequireDefault(require("../Button"));

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var StyledButton = (0, _styledComponents["default"])(_Button["default"]).withConfig({
  displayName: "ToolbarButton__StyledButton",
  componentId: "z0k4we-0"
})(function (props) {
  return (0, _styledComponents.css)(["font-weight:", ";display:flex;flex-direction:column;height:3.5rem;min-width:3.5rem;max-width:min-content;box-sizing:content-box;svg{flex-shrink:0;}"], props.theme.font.weight.black);
});

var Label = _styledComponents["default"].div.withConfig({
  displayName: "ToolbarButton__Label",
  componentId: "z0k4we-1"
})(function (_ref) {
  var theme = _ref.theme,
      disabled = _ref.disabled;
  return (0, _styledComponents.css)(["display:flex;align-items:center;font-size:", "rem;line-height:0.8rem;flex-grow:1;overflow:auto hidden;&::first-letter{text-transform:capitalize;}", ""], theme.font.size.caption, disabled && (0, _styledComponents.css)(["color:", ";"], theme.color.disabled));
});

var IconRenderer = function IconRenderer(_ref2) {
  var icon = _ref2.icon,
      active = _ref2.active,
      disabled = _ref2.disabled;

  var _React$useContext = _react["default"].useContext(_styledComponents.ThemeContext),
      color = _React$useContext.color;

  return /*#__PURE__*/_react["default"].cloneElement(icon, {
    color: active ? disabled ? color.disabled : color.paper : disabled ? color.disabled : color.action,
    secondaryColor: active ? disabled ? color.disabled : color.paper : disabled ? color.disabled : color.text,
    size: 24
  });
};
/**
 *
 * #### Styled button component

This button is intended to to be used with a `Toolbar` component hence its name. It requires an icon and label and generally works as a set of buttons within a `ButtonGroup`.

Please note: The supplied label should be no more than a couple of words in length due to the strictive width and height of the component. Any overflow will be trimmed/hidden.
 */


var ToolbarButton = function ToolbarButton(_ref3) {
  var _ref3$label = _ref3.label,
      label = _ref3$label === void 0 ? '' : _ref3$label,
      _ref3$icon = _ref3.icon,
      icon = _ref3$icon === void 0 ? null : _ref3$icon,
      _ref3$active = _ref3.active,
      active = _ref3$active === void 0 ? false : _ref3$active,
      _ref3$disabled = _ref3.disabled,
      disabled = _ref3$disabled === void 0 ? false : _ref3$disabled,
      _ref3$toggleable = _ref3.toggleable,
      toggleable = _ref3$toggleable === void 0 ? false : _ref3$toggleable,
      _ref3$onClick = _ref3.onClick,
      onClick = _ref3$onClick === void 0 ? function () {} : _ref3$onClick,
      children = _ref3.children,
      rest = _objectWithoutProperties(_ref3, ["label", "icon", "active", "disabled", "toggleable", "onClick", "children"]);

  return /*#__PURE__*/_react["default"].createElement(StyledButton, _extends({
    disabled: disabled,
    active: active,
    toggleable: toggleable,
    onClick: onClick
  }, rest), /*#__PURE__*/_react["default"].createElement(IconRenderer, {
    icon: icon,
    disabled: disabled,
    active: active
  }), /*#__PURE__*/_react["default"].createElement(Label, {
    disabled: disabled,
    active: active
  }, label), children);
};

var _default = ToolbarButton;
exports["default"] = _default;